// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3QO0l","header":"styles_header__381BV","content":"styles_content__2I_pH"};